import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import "./loan-steps.css";
import documentGif from "../assets/images/document.gif";
import formGif from "../assets/images/form-registration.gif";
import approvalGif from "../assets/images/approval.gif";
import verificationGif from "../assets/images/verification.gif";
import receivedfundsGif from "../assets/images/received-funds.gif";

const steps = [
  {
    id: 1,
    title: "Apply Online",
    desc: "Submit your loan application swiftly and securely",
    gif: formGif
  },
  {
    id: 2,
    title: "Upload Documents",
    desc: "Easily upload your KYC and income proofs with total privacy.",
    gif: documentGif
  },
  {
    id: 3,
    title: "Verification",
    desc: "Instant and accurate verification of your submitted details.",
    gif: verificationGif
  },
  {
    id: 4,
    title: "Approval",
    desc: "Receive quick confirmation within minutes.",
    gif: approvalGif
  },
  {
    id: 5,
    title: "Disbursal",
    desc: "Funds are promptly credited directly to your account",
    gif: receivedfundsGif
  }
];

const LoanSteps = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ls-animate-line");
          }
        });
      },
      { threshold: 0.5 }
    );

    const line = document.querySelector(".ls-progress-line");
    if (line) observer.observe(line);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="ls-section py-5">
      <Container>
        <h2 className="text-center ls-title mb-5">Loan Journey</h2>
        <div className="ls-wrapper">
          <div className="ls-progress-line"></div>
          {steps.map((step) => (
            <div className="ls-step-item" key={step.id}>
              <div className="ls-step-circle">
                <img src={step.gif} alt={step.title} className="ls-step-gif" />
                <span className="ls-step-num">{step.id}</span>
              </div>
              <h5>{step.title}</h5>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default LoanSteps;
